import { useEffect } from 'react';
/**
 * Registers a global keydown event handler.
 *
 * If you find yourself checking the event target, it may be better to attach the
 * event handler directly on that element.
 */ export function useKeyDown(callbacks, enabled = true, ignoreInputs = false) {
    useEffect(()=>{
        if (Object.keys(callbacks).length === 0 || !enabled) {
            return;
        }
        const handleKeyDown = (e)=>{
            if (ignoreInputs) {
                const source = e.target;
                if (source.className.includes('Draft') || source.tagName.match(/input|textarea/i)) {
                    return;
                }
            }
            if (callbacks.hasOwnProperty(e.key)) {
                callbacks[e.key](e);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>window.removeEventListener('keydown', handleKeyDown);
    }, [
        callbacks,
        enabled,
        ignoreInputs
    ]);
}
